import React from 'react';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import classes from './minimum-required-cbs.scss';
export const MinimumRequiredCBSPopup = ({
  open,
  onClose
}) => {
  const Content = () => /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, "In order to create a brand site, first find a product that you\u2019re interested in offering. Once you\u2019ve selected, you will need to first select the colors that you want the product to be offered in, upload your customers design, mock it up, and if needed, select decoration method. Once you\u2019ve added your first product, you will be able to repeat this flow and add as many products as you want to be offered on your customers curated brand site."), /*#__PURE__*/React.createElement("div", {
    className: classes.button
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    dataButton: "GetStarted",
    type: "primary"
  }, "Get Started!")));
  return /*#__PURE__*/React.createElement(InfoDialog, {
    dataPopup: "MinimumRequiredCBS",
    header: "You're creating a Minimum required curated brand site",
    className: classes.popup,
    titleClass: classes.titleWrapper,
    titleContentClass: classes.title,
    content: /*#__PURE__*/React.createElement(Content, null),
    onRequestClose: onClose,
    showCloseButton: true,
    open: open,
    isResponsive: true
  });
};